"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createMiddleware = function createMiddleware(errorHandler) {
  return function () {
    return function (next) {
      return function (action) {
        try {
          next(action);
          if (action.error) {
            errorHandler(action.error);
          }
        } catch (e) {
          errorHandler(e);
        }
      };
    };
  };
};

exports.default = createMiddleware;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/errorHandler.js
// module id = 1292
// module chunks = 0